import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Typography,
  Avatar,
  Box,
  Stack,
} from "@mui/material";
import EditBtn from "./actionBtn/editBtn";
import DeleteBtn from "./actionBtn/deleteBtn";
import { DEFAULT_EX_ICON } from "../constants/constants";
import defImg from "../assets/default-product-image.png";
import InteractiveAction2 from "./InteractiveAction2";

const ProductItem = ({
  product,
  onEditProduct,
  onDeleteProduct,
  viewMode = false,
}) => {
  return (
    <Card
      sx={{
        height: "100%",
        width: "100%",
        maxWidth: 320,
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        borderRadius: 2,
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
          transform: "translateY(-4px)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          paddingTop: "75%", // 4:3 aspect ratio for better product display
          overflow: "hidden",
          bgcolor: "grey.100",
        }}
      >
        <CardMedia
          component="img"
          image={product.images ? product.images[0] : defImg}
          alt={product.name}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>

      <CardContent sx={{ flexGrow: 1, pb: 1 }}>
        <Typography
          gutterBottom
          variant="body1"
          component="div"
          noWrap
          sx={{
            fontWeight: 600,
            mb: viewMode && product?.exhibitor ? 1.5 : 0,
          }}
        >
          {product.name}
        </Typography>

        {viewMode && product?.exhibitor && (
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{ mt: 1 }}
          >
            <Avatar
              src={
                product.exhibitor.profile_image
                  ? product.exhibitor.profile_image
                  : DEFAULT_EX_ICON
              }
              alt={product?.exhibitor?.companyShortName?.value}
              sx={{ width: 28, height: 28 }}
            />
            <Typography
              variant="body2"
              color="text.secondary"
              noWrap
              sx={{ flex: 1 }}
            >
              {product?.exhibitor?.companyShortName?.value}
            </Typography>
          </Stack>
        )}
      </CardContent>

      {viewMode ? (
        <Box px={2} pb={2}>
          <InteractiveAction2
            item={{
              username: product?.exhibitor?.username,
              productId: product._id,
            }}
            type={"product"}
          />
        </Box>
      ) : (
        <CardActions sx={{ pt: 0, px: 2, pb: 2 }}>
          <ProductItemAction
            onEdit={() => {
              if (onEditProduct) onEditProduct(product);
            }}
            onDelete={() => {
              if (onDeleteProduct) onDeleteProduct(product);
            }}
          />
        </CardActions>
      )}
    </Card>
  );
};

const ProductItemAction = ({ onEdit, onDelete }) => {
  return (
    <Box display="flex" width="100%" alignItems="center">
      <EditBtn onEdit={onEdit} />
      <Box flex={1}></Box>
      <DeleteBtn onDelete={onDelete} />
    </Box>
  );
};

export default ProductItem;
export { ProductItemAction };
